/**
 * Fábrica de instancias de axios para el panel de administración.
 *
 * Las páginas del panel creaban su propia instancia con
 * `axios.create({ withCredentials: true })`. Una instancia nueva copia los
 * *defaults* del módulo, pero NO sus interceptores, así que la cabecera CSRF y
 * el reintento de `@/lib/csrf` se quedaban fuera. Con esta fábrica todas las
 * instancias del panel nacen con lo mismo.
 */
import axios from "axios";
import { instalarCsrf } from "@/lib/csrf";

export function crearAxios(config = {}) {
  return instalarCsrf(axios.create({ withCredentials: true, ...config }));
}
